module.exports = __webpack_public_path__ + "img/4.a692b0af.png";